"use client"
import { useState } from "react"
import { type HoveredPowerItem } from "../../../../power-bubble-chart/hoveredPowerItem"

// Gives each variant the same hover contract for the shared tooltip body.
export const useDistributionOfPowerTooltip = () => {
  const [hoveredItem, setHoveredItem] = useState<HoveredPowerItem | null>(null)
  return {
    hoveredItem,
    setHoveredItem,
    clearHoveredItem: () => setHoveredItem(null),
  }
}
